
import { ISeriesApi } from "../lcharts/src/api/iseries-api";
import { Chart } from "../Chart";
import { LineWave, SerieColor } from "../LineSerie";
import { LineData } from '../lcharts/src/api/data-consumer';
import { SeriesPartialOptions, LineStyleOptions, priceExtendedType, ExtensionType } from '../lcharts/src/model/series-options';
import { LineStyle, LineType, IChartApi, LineWidth } from '../lcharts/src/api/create-chart';
import { BusinessDay, UTCTimestamp } from "lightweight-charts";

export class AnnotationHorizontalLine
{


  public horizontalLinesSerie: ISeriesApi<"Line">;
  public pricelInePoints:LineData[] = [];

  constructor(public chart:Chart,public priceValue:number, public time: UTCTimestamp | BusinessDay,public color:string)
  {

    this.horizontalLinesSerie = this.chart.chart.addLineSeries(this.lineOptions(), 0);
    let point:LineData = {time: time, value:priceValue};

    this.pricelInePoints.push(point)
    this.horizontalLinesSerie.setData(this.pricelInePoints);

  }

  public lineOptions():SeriesPartialOptions<LineStyleOptions>
  {
    return{
      color: this.color,
      lineStyle: LineStyle.Solid,
      lineWidth: 1,
      crosshairMarkerVisible: false,
      crosshairMarkerRadius: 6,
      lineType: LineType.Simple,
      priceLineVisible: true,//isExtended,
      lastValueVisible: false,
      priceLineColor: this.color,
      priceLineStyle: LineStyle.Dashed,
      priceLineWidth: (1) as LineWidth,
      priceLineExtended:true,//isExtended,
      priceLineExtendedType: ExtensionType.Left//(isExtended)?ExtensionType.Right:ExtensionType.None
  }
   }

   public standardOption():SeriesPartialOptions<LineStyleOptions>
   {
    return{
      color: SerieColor.STANDARD,
      lineStyle: LineStyle.Solid,
      lineWidth: 1,
      crosshairMarkerVisible: true,
      crosshairMarkerRadius: 6,
      lineType: LineType.Simple,
      priceLineVisible: true,
      lastValueVisible: true,
      priceLineColor: SerieColor.PRICELINE,
      priceLineStyle: LineStyle.LargeDashed,

  }
   }
}
